import { useQuery } from 'common/hooks';
import { UseQueryOptions } from 'common/types/Api.type';
import { getPraiseHeadlineOptionsApi } from '../praise.service';

export const useGetHeadlineOptions = (options: UseQueryOptions = {}) => {
  const queryResponse = useQuery(
    ['headline-options'],
    () => getPraiseHeadlineOptionsApi(),
    options,
  );

  return {
    ...queryResponse,
    data: queryResponse?.data?.data?.headlineOptions,
  };
};
